import { useEffect, useRef } from "react";
import { Form, Button, Input, Space, Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CommonTable from "../../commonComponents/Table/table";
import { useStudioUsers, useAddStudioUser } from "../../hooks/useStudioUsers";
import { useDeleteUser } from "../../hooks/useUsers";

const StudioUsers = (props) => {
  const username = useRef(null);
  const email = useRef(null);
  const designation = useRef(null);
  const formRef = useRef(null);

  const [api, contextHolder] = notification.useNotification();

  const transFormData = (data) => {
    return data.map((item) => {
      return {
        key: `${item._id}`,
        name: `${item.name}`,
        email: `${item.email}`,
        designation: `${item.designation}`,
      };
    });
  };

  const onSuccess = (values) => {
    refetch();
    // alert("Operation successfully Completed");
    api["success"]({
      message: "Operation successfully Completed",
    });
    username.current.input.value = "";
    email.current.input.value = "";
    designation.current.input.value = "";
  };
  const onDeleteSuccess = (values) => {
    refetch();
    // alert("Operation successfully Completed");
    api["success"]({
      message: "Operation delete successfully Completed",
    });
    username.current.input.value = "";
    email.current.input.value = "";
    designation.current.input.value = "";
  };

  const onError = (error) => {
    api["error"]({
      message: error.response.data.message,
    });
  };

  const {
    data: Users,
    refetch,
    isLoading,
    isError,
    error,
    isFetching,
  } = useStudioUsers(props.id, null, onError, transFormData);
  const { mutate: addUsers } = useAddStudioUser(props.id, onSuccess, onError);
  const { mutate: deleteUser } = useDeleteUser(onDeleteSuccess, onError);

  useEffect(() => {
    refetch();
  }, [props.id]);

  const InnerTableCols = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
    },
    {
      title: "Action",
      key: "key",
      render: (_, record) => (
        <Space size="middle">
          <Button onClick={() => handelDelete(record)} type="primary" danger>
            Delete
          </Button>
        </Space>
        // <Space size="middle">
        //   <a>Invite {record.name}</a>
        //   <a>Delete</a>
        // </Space>
      ),
    },
  ];
  const handelSubmit = (values) => {
    addUsers({
      name: username.current.input.value,
      email: email.current.input.value,
      designation: designation.current.input.value,
    });
    formRef.current.resetFields();
  };
  const handelDelete = (id) => {
    deleteUser(id.key);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const spinIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
        color: "#1890ff",
      }}
      spin
    />
  );

  return (
    <div>
      {contextHolder}
      <h1>
        Studio: {props.title}{" "}
        {isFetching && (
          <Space size="large">
            <Spin size="default"></Spin>
          </Space>
        )}
      </h1>
      <Form
        name="new_user"
        onFinish={handelSubmit}
        autoComplete="off"
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        initialValues={{ size: "small" }}
        // onValuesChange={onFormLayoutChange}
        onFinishFailed={onFinishFailed}
        size="small"
        ref={formRef}
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          name="studioUser"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter  name!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input ref={username} required />
        </Form.Item>
        <Form.Item
          name="useremail"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter useremail name!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input ref={email} required />
        </Form.Item>
        <Form.Item
          name="designation"
          label="Designation"
          rules={[
            {
              required: true,
              message: "Please enter designation name!",
            },
            {
              validator: (_, value) =>
                value && !value.trim()
                  ? Promise.reject(new Error("No spaces allowed"))
                  : Promise.resolve(),
            },
          ]}
        >
          <Input ref={designation} required />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" type="primary">
            Create User
          </Button>
        </Form.Item>
      </Form>

      <CommonTable
        columns={InnerTableCols}
        data={Users}
        bordered
        loading={{
          spinning: isFetching,
          indicator: spinIcon,
        }}
      />
    </div>
  );
};

export default StudioUsers;
